import { useMutation, useQueryClient } from '@tanstack/react-query';
import campaignService from 'v2/services/campaigns';

interface EditProductCampaignParams {
  productId: number;
  campaignId: number;
  data: any;
}

export function useEditProductCampaign() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ productId, campaignId, data }: EditProductCampaignParams) =>
      campaignService.editProductCampaign(productId, campaignId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productCampaigns'] });
    }
  });
}
